export default __webpack_public_path__ + "static/media/forestly-expl-dissect-06_EN.cfffe23c.png";